import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import styled from 'react-emotion';

import CloseIcon from '../Icons/CloseIcon/CloseIcon';
import { hideAlertBanner } from '../../redux/actions/alertBanner';
import { Paragraph } from '../Text/Text';
import Style from '../../styles/common';

const Container = styled('div')`
  align-items: center;
  background-color: ${Style.color.ALERT_BANNER_PRIMARY};
  border-top: 1px solid ${Style.color.MASTHEAD_BORDER};
  box-shadow: 0 -2px 5px 0 rgba(0, 0, 0, 0.05);
  display: flex;
  height: ${Style.MEASUREMENT.ALERT_BANNER.HEIGHT}px;
  justify-content: space-between;
  padding: 0 ${Style.SPACING.XL};
  position: fixed;
  bottom: 0;
  width: 100%;
  z-index: 10;
`;

const Content = styled('div')`
  align-items: center;
  display: flex;
`;

const MessageIcon = styled('img')`
  margin-right: ${Style.SPACING.XS};
  max-height: 35px;
`;

class AlertBanner extends Component {
  render() {
    if (!this.props.isVisible) return null;

    const messageIcon = this.props.icon ? (
      <MessageIcon src={this.props.icon} />
    ) : null;

    return (
      <Container>
        <Content>
          {messageIcon}
          <Paragraph>{this.props.message}</Paragraph>
        </Content>
        <CloseIcon
          onClick={this.onClick}
          size="lg"
        />
      </Container>
    );
  }

  onClick = () => {
    this.props.hideAlertBanner(this.props.banner);
  }
}

AlertBanner.propTypes = {
  banner: PropTypes.string.isRequired,
  icon: PropTypes.string,
  message: PropTypes.string.isRequired,
};

AlertBanner.defaultProps = {
  icon: '',
  isVisible: false,
};

export default connect(
  (state, initialProps) => ({
    isVisible: state.alertBanner[initialProps.banner],
  }),
  { hideAlertBanner }
)(AlertBanner);



// WEBPACK FOOTER //
// ./src/components/AlertBanner/AlertBanner.js